export default __webpack_public_path__ + "static/images/8604c3b5bd5af770b58fbf5df21857f5.png";